const formTrackingType = Object.freeze({
	formOpen: 'click',
	formSubmit: 'submit',
});

class FormTracking {

	/**
	 * @type {null | string}
	 */
	static openFormBtnClasses = '#contact-modal-button';

	/**
	 * @type {null | HTMLFormElement}
	 */
	element = null;

	/**
	 * @type {null | string}
	 */
	trackingType = null;

	/**
	 * @param {HTMLFormElement} element - The form to track
	 * @param {string} trackingType - The form to track
	 * @returns {void}
	 */
	constructor(element, trackingType) {
		if (!element) return;

		this.element = element;
		this.trackingType = trackingType;

		this.#registerEvents();
	}

	/**
	 * Adds event listeners to and calls the correct event handler
	 * @returns {void}
	 */
	#registerEvents() {
		this.element.addEventListener('click', () => {
			if (this.trackingType === formTrackingType.formSubmit) this.#handleSubmitEvent();
			if (this.trackingType === formTrackingType.formOpen) this.#handleOpenEvent();
		});
	}

	/**
	 * @returns {void}
	 */
	#handleOpenEvent() {
		window.dataLayer.push({
			'event': 'formclick',
		});
	}

	/**
	 * @returns {void}
	 */
	#handleSubmitEvent() {
		window.dataLayer.push({
			'event': 'formsubmit',
		});
	}
}

const run = () => {
	document.querySelectorAll('#contact-modal-button').forEach((el) => {
		new FormTracking(el, formTrackingType.formOpen);
	});

	document.querySelectorAll('.dc-form-wrapper button[type="submit"]').forEach((el) => {
		new FormTracking(el, formTrackingType.formSubmit);
	});
}

export default () => {
	setTimeout(() => {
		if (document.readyState === "interactive" || document.readyState === "complete" ) {
			run();
		} else {
			document.addEventListener('DOMContentLoaded', run);
		}
	}, 500);
};
